import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import baseURL from '../../url';
import '../Register/Register.css';

export default function EditUsuario({ usuario, isOpen, onClose, onSuccess }) {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [rol, setRol] = useState('usuario');
    const [contrasena, setContrasena] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cargando, setCargando] = useState(false);

    useEffect(() => {
        if (usuario && isOpen) {
            setNombre(usuario.nombre || '');
            setEmail(usuario.email || '');
            setRol(usuario.rol || 'usuario');
            setContrasena('');
            setShowPassword(false);
        }
    }, [usuario, isOpen]);

    if (!isOpen || !usuario) {
        return null;
    }

    const handleGuardar = async (e) => {
        e.preventDefault();

        if (!nombre.trim() || !email.trim()) {
            toast.error('Nombre y Email son obligatorios');
            return;
        }

        if (contrasena && contrasena.length < 6) {
            toast.error('La contraseña debe tener al menos 6 caracteres');
            return;
        }

        setCargando(true);
        try {
            const bodyData = {
                nombre: nombre.trim(),
                email: email.trim(),
                rol: rol,
            };

            if (contrasena.trim()) {
                bodyData.contrasena = contrasena.trim();
            }

            const response = await fetch(`${baseURL}/usuariosGet.php?idUsuario=${usuario.idUsuario}`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyData),
            });

            const data = await response.json();

            if (response.ok && data.mensaje) {
                toast.success(data.mensaje || 'Usuario actualizado correctamente');
                if (onSuccess) onSuccess();
                onClose();
            } else {
                toast.error(data.error || 'Error al actualizar el usuario');
            }
        } catch (error) {
            console.error('Error al actualizar usuario:', error);
            toast.error('Ocurrió un error al actualizar el usuario');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <div className='deFlexBack'>
                    <h4>Editar Usuario</h4>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>

                <form onSubmit={handleGuardar} id='crearForm'>
                    <div className='flexGrap'>
                        <fieldset>
                            <legend>Nombre</legend>
                            <input
                                type="text"
                                id="edit_nombre"
                                name="nombre"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                required
                                placeholder="Nombre completo"
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Email</legend>
                            <input
                                type="email"
                                id="edit_email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="Correo electrónico"
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Rol</legend>
                            <select
                                id="edit_rol"
                                name="rol"
                                value={rol}
                                onChange={(e) => setRol(e.target.value)}
                                required
                            >
                                <option value="usuario">Usuario</option>
                                <option value="admin">Admin</option>
                            </select>
                        </fieldset>

                        <fieldset>
                            <legend>Contraseña (Opcional)</legend>
                            <div className='deFlexPass'>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="edit_contrasena"
                                    name="contrasena"
                                    value={contrasena}
                                    onChange={(e) => setContrasena(e.target.value)}
                                    placeholder="Dejar en blanco para no cambiar"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Ocultar" : "Mostrar"}
                                >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </button>
                            </div>
                        </fieldset>
                    </div>

                    {cargando ? (
                        <button type="button" className='btnLoading' disabled>
                            Guardando...
                        </button>
                    ) : (
                        <button type="submit" className='btnPost'>
                            Guardar Cambios
                        </button>
                    )}
                </form>
            </div>
        </div>
    );
}
